import '../style.scss';

import React from 'react';
import { connect } from 'react-redux';
import OrderLoading from './loading';
import OrderHeading from './heading';
import OrderAddress from './address';
import OrderProductsList from './productsList';
import OrderLineItems from './lineItems';
import OrderPayment from './payment';
import Card from 'components/ui/card';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import {
  isCanceledOrder,
  isFailedOrder,
  isReturnedOrder
} from 'shared/models/order';
import { loadOrder } from '../actions';

class OrderHistoryOrder extends React.Component {
  componentDidMount() {
    const oldOrder = this.props.order || {};
    const routeParams = this.props.match.params || {};
    if (oldOrder._id !== routeParams.id && !this.props.loading)
      this.props.loadOrder(routeParams.id);
  }

  render() {
    const { loading, order } = this.props;
    if (loading) return <OrderLoading />;
    if (!order) return null;

    const wasReturned = isReturnedOrder(order);
    const wasCanceled = isCanceledOrder(order) || isFailedOrder(order);
    const refundedAmount = (order.refunded_amount || 0).toFixed(2);

    return (
      <View padding={{ sides: 'md' }} className="order-history banner-padding">
        <OrderHeading
          orderDate={order.order_date}
          wasCanceled={wasCanceled}
          wasReturned={wasReturned}
        />

        <Card block>
          <OrderAddress order={order} />
          <View padding={{ sides: 'md' }}>
            <OrderProductsList order={order} />
            {!wasCanceled && !wasReturned && <OrderLineItems order={order} />}
            <OrderPayment order={order} />
          </View>
        </Card>

        {wasCanceled && (
          <View padding={{ top: 'xs', sides: 'md' }}>
            <Text tag="p" secondary className="text-center">
              If a cancellation occurred after the order was picked up or if a
              delivery was attempted and the customer was unavailable to receive
              the delivery, a cancellation fee may apply.
            </Text>
          </View>
        )}

        {wasReturned &&
          !!refundedAmount && (
            <View padding={{ top: 'xs', sides: 'md' }}>
              <Text tag="p" secondary className="text-center">
                We have canceled the order and refunded you for the item(s) for
                a total of ${refundedAmount}. Unfortunately, we do have to
                recoup the shipping costs for the attempts and return with the
                carrier.
              </Text>
            </View>
          )}
      </View>
    );
  }
}

const ConnectedOrderHistoryOrder = connect(
  state => ({
    order: state.orderHistory.order,
    loading: state.orderHistory.orderLoading
  }),
  { loadOrder }
)(OrderHistoryOrder);

export default ConnectedOrderHistoryOrder;
